/**
 * WEB-1909 — умолчание языка ВОРОНКИ на фронте (зеркало серверной константы
 * `backend/src/shared/constants/default-funnel-language.ts`).
 *
 * Решение владельца (05.09): автор не назвал язык → воронка русская. Значение
 * обязано совпадать с серверным байт-в-байт: сервер ставит его при создании,
 * конструктор — до первого ответа сервера и как страховку «ответ без поля».
 * Совпадение держит сторож `defaultFunnelLanguage.twoEnds.web1909.guard.test.ts`.
 *
 * ЭТО НЕ язык КАБИНЕТА (`i18n/`, поле профиля, умолчание `en` по WEB-1874):
 * там правило другое — язык интерфейса автора, а здесь язык содержимого
 * воронки для её посетителя.
 */
export const DEFAULT_FUNNEL_LANGUAGE = "ru";
